import {
  LockKeyhole,
  LogsIcon,
  TypeOutlineIcon,
  UsersRoundIcon,
  WorkflowIcon,
  WrenchIcon,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { LenderUserRoleEnum } from "@/features/common/enums";
import { useGetCurrentLenderCompanyQuery } from "@/features/lender-companies/hooks/use-get-lender-company.query";

import { NavGroup } from "./nav-group";

export const NavAdmin = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: lenderCompany } = useGetCurrentLenderCompanyQuery();

  if (lenderCompany?.userSettings?.role === LenderUserRoleEnum.CREDIT_OFFICER) {
    return null;
  }

  const is = (segment: string) => pathname.endsWith(segment);

  const adminItems = {
    title: "Admin",
    icon: LockKeyhole,
    isActive: is("/company-profile") || is("/team"),
    items: [
      {
        title: "Lender profile",
        onClick: () =>
          navigate(`/lender-company/${lenderCompany?.id}/company-profile`),
        isActive: is("/company-profile"),
        icon: TypeOutlineIcon,
      },
      {
        title: "Team",
        onClick: () => navigate(`/lender-company/${lenderCompany?.id}/team`),
        isActive: is("/team"),
        icon: UsersRoundIcon,
      },
    ],
  };

  const developerItems = {
    title: "Developer",
    icon: WorkflowIcon,
    isActive: is("/api") || is("/api-logs"),
    items: [
      {
        title: "API Configuration",
        onClick: () => navigate(`/lender-company/${lenderCompany?.id}/api`),
        isActive: is("/api"),
        icon: WrenchIcon,
      },
      {
        title: "Integration log",
        onClick: () =>
          navigate(`/lender-company/${lenderCompany?.id}/api-logs`),
        isActive: is("/api-logs"),
        icon: LogsIcon,
      },
    ],
  };

  if (lenderCompany?.userSettings?.role === LenderUserRoleEnum.DEVELOPER) {
    return <NavGroup items={[developerItems]} />;
  }

  return <NavGroup items={[adminItems, developerItems]} />;
};
